import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider as DescopeAuthProvider } from '@descope/react-sdk';

import App from './App';
import { theme } from './theme';
import { config } from './core/config/env';
import { AuthProvider } from './core/contexts/AuthContext';
import { TenantProvider } from './core/contexts/TenantContext';

// Vite injects BASE_URL based on the `base` config option. Stripping the
// trailing slash gives React Router its `basename` so client routes work
// both at `/` (dev) and `/backoffice` (production behind the backend).
const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={routerBasename}>
          <DescopeAuthProvider projectId={config.descopeProjectId}>
            <AuthProvider>
              <TenantProvider>
                <App />
              </TenantProvider>
            </AuthProvider>
          </DescopeAuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
